import styled from 'styled-components';
import React from 'react';
import { Table } from '@material-ui/core';
import CheckIcon from 'assets/svg/CheckIcon';
import uuid from 'uuid';

const ColumnHeader = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1 0 0;
  border-radius: 2px;
`;

const RolesHeader = styled.div`
  display: flex;
  width: 242px;
  padding: 20px 4px;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

const PermissionHeader = styled.div`
  display: flex;
  width: 690px;
  padding: 20px 4px;
  align-items: center;
  gap: 6px;
  flex: 1 0 0;
`;

const RolesText = styled.text`
  color: var(--dark-content-fcfcfc, #fcfcfc);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  align-items: flex-start;
  flex: 1 0 0;
  border-radius: 2px;
`;

const PermissionText = styled.text`
  color: var(--dark-content-fcfcfc, #fcfcfc);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  border-radius: 2px;
`;

const Divider = styled.div`
  height: 1px;
  align-self: stretch;
  background: var(--border-medium, rgba(255, 255, 255, 0.35));
`;

const TableBackGroundRole = styled.div`
  display: flex;
  padding: 0px 14px;
  align-items: flex-start;
  gap: 8px;
  border-radius: 2px 2px 0px 0px;
  background: var(--dark-background-elevation-2373746, #373746);
`;

const GenericDiv = styled.div`
  display: flex;
  width: 250px;
  padding: 9px 4px;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  background: var(--dark-background-elevation-2373746, #373746);
`;

const PermissionTable = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 2px 2px 0px 0px;
  background: var(--dark-background-elevation-2373746, #373746);
`;

const RowContent = styled.tbody`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--dark-background-elevation-2373746, #373746);
`;

const PermissionSubHeader = styled.thead`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 2px 2px 0px 0px;
  background: var(--dark-background-elevation-2373746, #373746);
`;

const RolesEmptySubHeader = styled.th`
  width: 250px;
  padding: 9px 4px;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

const RolesEmptySubHeaderTD = styled.td`
  width: 250px;
  align-items: left;
  gap: 6px;
  flex-shrink: 0;
`;

const PermissionSubHeaderTH = styled.th`
  width: 690px
  padding: 9px 4px;
  align-items: center;
  gap: 6px;
  flex: 1 0 0;`;

const ColumnHeaderLabel = styled.text`
  color: var(--dark-content-fcfcfc, #fcfcfc);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const GenericTD = styled.div`
  display: flex;
  padding: 9px 4px 9px 16px;
  align-items: center;
  gap: 6px;
  flex: 1 0 0;
  display: flex;
  width: 250px;
  align-items: flex-start;
`;

const PermissionRowContent = styled.td`
  width: 690px
  padding: 9px 4px;
  align-items: center;
  gap: 6px;
  flex: 1 0 0;`;

const GenericUserText = styled.text`
  color: var(--dark-content-fcfcfc, #fcfcfc);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  flex: 1 0 0;
`;

const RowCell = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1 0 0;
  border-radius: 2px;
  display: flex;
  width: 28px;
  height: 22px;
  align-items: flex-start;
  margin-left: 9px;
`;

const JustificationDiv = styled.div`
  height: 17px;
  align-self: stretch;
  margin-top: 20px;
`;

const BJustiBottomText = styled.text`
  color: var(--dark-content-fcfcfc, #fcfcfc);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const JustificationLastDiv = styled.div`
  height: 17px;
  align-self: stretch;
  margin-top: 8px;
`;

const LastText = styled.text`
  color: var(--dark-content-fcfcfc, #fcfcfc);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Avenir Next;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  align-self: stretch;
`;

const rolesPermissionheadersData = [
  {
    header: '',
    subHeader: 'Generic user',
  },
  {
    header: 'Create deals',
    subHeader: '',
  },
  {
    header: 'Deal comparison',
    subHeader: '',
  },
  {
    header: 'Pareto',
    subHeader: '',
  },
  {
    header: 'Portfolio',
    subHeader: '',
  },
];

export default function UnauthorizedModal() {
  return (
    <div data-testid="unauthorized-page-modal-div">
      <TableBackGroundRole>
        <Table>
          <thead>
            <tr key={uuid()}>
              <th key={uuid()}>
                <RolesHeader>
                  <RolesText>Roles</RolesText>
                </RolesHeader>
              </th>
              <th key={uuid()}>
                <PermissionHeader>
                  <PermissionText>Permission</PermissionText>
                </PermissionHeader>
              </th>
            </tr>
          </thead>
        </Table>
      </TableBackGroundRole>
      <Divider />
      <PermissionTable>
        <Table>
          <PermissionSubHeader>
            <tr key={uuid()}>
              {rolesPermissionheadersData.map((header: { header: string; subHeader: string }) => (
                <>
                  {header.header === '' ? (
                    <RolesEmptySubHeader key={uuid()}>
                      <GenericDiv>
                        <PermissionText>{header.header}</PermissionText>
                      </GenericDiv>
                    </RolesEmptySubHeader>
                  ) : (
                    <PermissionSubHeaderTH key={uuid()}>
                      <ColumnHeader>
                        <ColumnHeaderLabel>{header.header}</ColumnHeaderLabel>
                      </ColumnHeader>
                    </PermissionSubHeaderTH>
                  )}
                </>
              ))}
            </tr>
          </PermissionSubHeader>
          <Divider />
          <RowContent>
            <tr key={uuid()}>
              {rolesPermissionheadersData.map((header: { header: string; subHeader: string }) => (
                <>
                  {header.header === '' ? (
                    <RolesEmptySubHeaderTD>
                      <GenericTD>
                        <GenericUserText>{header.subHeader}</GenericUserText>
                      </GenericTD>
                    </RolesEmptySubHeaderTD>
                  ) : (
                    <PermissionRowContent>
                      <RowCell>
                        <ColumnHeaderLabel>
                          <CheckIcon />
                        </ColumnHeaderLabel>
                      </RowCell>
                    </PermissionRowContent>
                  )}
                </>
              ))}
            </tr>
          </RowContent>
        </Table>
      </PermissionTable>

      <JustificationDiv>
        <BJustiBottomText>Please follow the below example for Business Justification</BJustiBottomText>
      </JustificationDiv>
      <JustificationLastDiv>
        <LastText>As per the business roles and responsibilities assigned I need access to Deal analyser</LastText>
      </JustificationLastDiv>
    </div>
  );
}
